import { render, staticRenderFns } from "./ItsBaseMaterRel.vue?vue&type=template&id=b393f2e0&scoped=true&"
import script from "./ItsBaseMaterRel.vue?vue&type=script&lang=js&"
export * from "./ItsBaseMaterRel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b393f2e0",
  null
  
)

export default component.exports